import React from 'react';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { Box, IconButton, Popover, Typography } from '@mui/material';

import {
  ChevronLeftOutlined,
  ChevronRightOutlined,
  CloseOutlined
} from '@mui/icons-material';

import DataHx from '../../../Default/components/Home/components/DataHx';
import {
  closeButtonSx,
  popoverPaperSx,
  recapContentSx,
  recapDescriptionSx,
  recapFooterSx,
  recapHeaderSx,
  recapTitleSx
} from '../../../Default/components/Home/components/styles';

const RecapPopover = ({ anchorEl, onClose, open, selectedPatient }) => {
  const popoverId = open ? 'patient-recap-popover' : undefined;

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      elevation={3}
      id={popoverId}
      open={open}
      slotProps={{
        paper: {
          sx: popoverPaperSx
        }
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      onClose={onClose}>
      <Box sx={recapHeaderSx}>
        <Box>
          <Typography sx={recapTitleSx}>Recap</Typography>

          <Typography sx={recapDescriptionSx}>
            {selectedPatient
              ? `${selectedPatient.pname} has 30 recap events`
              : 'The patient has 30 recap events'}
          </Typography>
        </Box>

        <IconButton
          aria-label="Close recap"
          sx={closeButtonSx}
          onClick={onClose}>
          <CloseOutlined />
        </IconButton>
      </Box>

      <PerfectScrollbar
        options={{
          suppressScrollX: true
        }}>
        <Box sx={recapContentSx}>
          <DataHx />
        </Box>
      </PerfectScrollbar>

      <Box sx={recapFooterSx}>
        <IconButton aria-label="Previous recap" disabled size="small">
          <ChevronLeftOutlined />
        </IconButton>

        <IconButton aria-label="Next recap" size="small">
          <ChevronRightOutlined />
        </IconButton>
      </Box>
    </Popover>
  );
};

RecapPopover.propTypes = {
  anchorEl: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedPatient: PropTypes.shape({
    dob: PropTypes.string,
    id: PropTypes.number,
    lastVisit: PropTypes.string,
    pname: PropTypes.string,
    sex: PropTypes.string
  })
};

RecapPopover.defaultProps = {
  anchorEl: null,
  selectedPatient: null
};

export default RecapPopover;
